import { render } from "./LookupCloneModal.vue?vue&type=template&id=b82f5600&scoped=true&ts=true"
import script from "./LookupCloneModal.vue?vue&type=script&lang=ts"
export * from "./LookupCloneModal.vue?vue&type=script&lang=ts"

import "./LookupCloneModal.vue?vue&type=style&index=0&id=b82f5600&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b82f5600"]])

export default __exports__